/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */
declare const __MDI_VERSION__: string

// Styles
import '@mdi/font/css/materialdesignicons.css';
import mdiWoff2Url from '@mdi/font/fonts/materialdesignicons-webfont.woff2?url';
import mdiTtfUrl from '@mdi/font/fonts/materialdesignicons-webfont.ttf?url';
import mdiWoffUrl from '@mdi/font/fonts/materialdesignicons-webfont.woff?url';
import mdiEotUrl from '@mdi/font/fonts/materialdesignicons-webfont.eot?url';

function preloadFont(font: any, format: string) {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'font';
    link.href = `${font}?v=${__MDI_VERSION__}`;
    link.type = `font/${format}`;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
}
preloadFont(mdiWoff2Url, 'woff2');
preloadFont(mdiTtfUrl, 'ttf');
preloadFont(mdiWoffUrl, 'woff');
preloadFont(mdiEotUrl, 'eot');

import 'vuetify/styles';
import { en, pt } from 'vuetify/locale';
// Composables
import { createVuetify } from 'vuetify';
import { vuetifyColors } from '@theme';
import type { VAlert, VAutocomplete, VBanner, VBtn, VTextarea, VTextField } from 'vuetify/lib/components/index.mjs';

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    defaults: {
        VTextField: {
            density: 'compact',
            hideDetails: 'auto',
            variant: 'outlined',
            bgColor: 'gray-100',
        } as VTextField['$props'],
        VBtn: {
            elevation: 0,
            ripple: false,
        } as VBtn['$props'],
    },
    locale: {
        locale: 'pt',
        fallback: 'en',
        messages: { pt, en },
    },
    display: {
        mobileBreakpoint: 'sm',
        thresholds: {
            xs: 0,
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1280,
            xxl: 1536,
        },
    },
    theme: {
        themes: {
            light: {
                colors: vuetifyColors(),
            },
        },
    },
});
